'use client'
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var index_exports = {};
__export(index_exports, {
  EApiRequestKey: () => EApiRequestKey,
  addBuddiesAPI: () => addBuddiesAPI,
  addTicketsApi: () => addTicketsApi,
  applyOrRemoveCoupon: () => applyOrRemoveCoupon,
  callApi: () => callApi,
  changePersonStatusAPI: () => changePersonStatusAPI,
  claimTicketForEvent: () => claimTicketForEvent,
  closeDownEvent: () => closeDownEvent,
  createEvent: () => createEvent,
  createEventWeb: () => createEventWeb,
  createOrganizationAPI: () => createOrganizationAPI,
  createPaymentSheetApi: () => createPaymentSheetApi,
  deleteTicketApi: () => deleteTicketApi,
  deleteUserAPI: () => deleteUserAPI,
  eventGoLive: () => eventGoLive,
  fetchGuestListForEvent: () => fetchGuestListForEvent,
  fetchSuggestedBuddies: () => fetchSuggestedBuddies,
  followOrganizationAPI: () => followOrganizationAPI,
  getAcceptedGuestAvatarsApi: () => getAcceptedGuestAvatarsApi,
  getAllEvents: () => getAllEvents,
  getAllTicketsApi: () => getAllTicketsApi,
  getEventDetails: () => getEventDetails,
  getEventTemplatesAPI: () => getEventTemplatesAPI,
  getGroupDetails: () => getGroupDetails,
  getOrganizationAPI: () => getOrganizationAPI,
  getOrganizationEventsAPI: () => getOrganizationEventsAPI,
  getUserInfo: () => getUserInfo,
  increaseInterestedCountApi: () => increaseInterestedCountApi,
  joinEvent: () => joinEvent,
  joinWaitlistForEvent: () => joinWaitlistForEvent,
  leaveEventApi: () => leaveEventApi,
  leaveNonTicketedEventApi: () => leaveNonTicketedEventApi,
  markUserAsPermanent: () => markUserAsPermanent,
  onboardUserToStripe: () => onboardUserToStripe,
  processGroupTicketsAPI: () => processGroupTicketsAPI,
  queryOpenAPIForDescription: () => queryOpenAPIForDescription,
  requestPluginAPI: () => requestPluginAPI,
  resendEmailVerificationAPI: () => resendEmailVerificationAPI,
  searchEvents: () => searchEvents,
  sendExperimentEngagementToSlack: () => sendExperimentEngagementToSlack,
  sendFeedbackForEvent: () => sendFeedbackForEvent,
  setPlusOnes: () => setPlusOnes,
  unfollowOrganizationAPI: () => unfollowOrganizationAPI,
  updateEmailAPI: () => updateEmailAPI,
  updateTicketApi: () => updateTicketApi,
  updateUserDetails: () => updateUserDetails,
  validateToken: () => validateToken
});
module.exports = __toCommonJS(index_exports);

// src/transport/index.ts
var callApi = async (functions, query) => {
  return functions.httpsCallable(query.path)(query.data).then((result) => {
    return result.data;
  }).catch((error) => {
    console.error(`[API ERROR] path: ${query.path}`, error);
    throw error;
  });
};

// src/types/apiTypes.ts
var EApiRequestKey = /* @__PURE__ */ ((EApiRequestKey2) => {
  EApiRequestKey2["getSuggestedPeople"] = "authAndProfiles-getSuggestedPeople";
  EApiRequestKey2["addBuddy"] = "authAndProfiles-addBuddy";
  EApiRequestKey2["changePersonStatus"] = "authAndProfiles-changePersonStatus";
  EApiRequestKey2["GetEventDetails"] = "eventManagement-getEventDetailsAndRestrictions";
  EApiRequestKey2["JoinEvent"] = "eventManagement-joinEvent";
  EApiRequestKey2["getAllTickets"] = "eventManagement-getAllTickets";
  EApiRequestKey2["createPaymentSheet"] = "eventManagement-createPaymentSheet";
  EApiRequestKey2["leaveEvent"] = "eventManagement-leaveEvent";
  EApiRequestKey2["closeDownEvent"] = "eventManagement-closeDownEvent";
  EApiRequestKey2["IncreaseInterestedCount"] = "eventManagement-increaseInterestedCount";
  EApiRequestKey2["validateToken"] = "eventManagement-validateToken";
  EApiRequestKey2["markUserAsPermanent"] = "eventManagement-markUserAsPermanent";
  EApiRequestKey2["getAllEvents"] = "eventManagement-getAllEvents";
  EApiRequestKey2["searchEvent"] = "eventManagement-genericQueryForEventFn";
  EApiRequestKey2["plusOnes"] = "eventManagement-addPlusOnes";
  EApiRequestKey2["getAcceptedGuestAvatarsApi"] = "eventManagement-getAcceptedGuestAvatars";
  EApiRequestKey2["fetchGuestListForEvent"] = "eventManagement-fetchGuestListForEvent";
  EApiRequestKey2["claimTicketForEvent"] = "eventManagement-claimTicket";
  EApiRequestKey2["processGroupTickets"] = "eventManagement-processGroupTickets";
  EApiRequestKey2["applyOrRemoveCoupon"] = "eventManagement-applyOrRemoveCoupon";
  EApiRequestKey2["getEventTemplates"] = "eventManagement-getEventTemplates";
  EApiRequestKey2["joinWaitlistForEvent"] = "eventManagement-joinWaitlistForEvent";
  EApiRequestKey2["createEvent"] = "eventManagement-createEvent";
  EApiRequestKey2["createEventWeb"] = "eventManagement-createEventV2";
  EApiRequestKey2["eventGoLive"] = "eventManagement-eventGoLive";
  EApiRequestKey2["onboardUserToStripe"] = "eventManagement-onboardUser";
  EApiRequestKey2["addTicket"] = "eventManagement-addTickets";
  EApiRequestKey2["queryOpenAPIForDescription"] = "eventManagement-queryOpenAPIForDescription";
  EApiRequestKey2["sendFeedbackForEvent"] = "eventManagement-sendFeedbackForEvent";
  EApiRequestKey2["deleteTicket"] = "eventManagement-deleteTicket";
  EApiRequestKey2["updateTicket"] = "eventManagement-updateTicket";
  EApiRequestKey2["GetGroupDetails"] = "groupManagement-getGroupDetails";
  EApiRequestKey2["createOrganization"] = "organizationManagement-createOrganization";
  EApiRequestKey2["getOrganization"] = "organizationManagement-getOrganization";
  EApiRequestKey2["followOrganization"] = "organizationManagement-followOrganization";
  EApiRequestKey2["unfollowOrganization"] = "organizationManagement-unfollowOrganization";
  EApiRequestKey2["getOrganizationEvents"] = "organizationManagement-getOrganizationEvents";
  EApiRequestKey2["updateUserDetails"] = "authAndProfiles-updateProfile";
  EApiRequestKey2["getUserInfo"] = "authAndProfiles-getBudddyInfo";
  EApiRequestKey2["updateEmail"] = "authAndProfiles-updateEmail";
  EApiRequestKey2["resendEmailVerification"] = "authAndProfiles-resendEmailVerification";
  EApiRequestKey2["deleteUser"] = "authAndProfiles-deleteUser";
  EApiRequestKey2["sendExperimentEngagementToSlack"] = "services-sendExperimentEngagementToSlack";
  EApiRequestKey2["requestPlugin"] = "pluginManagement-requestPlugin";
  return EApiRequestKey2;
})(EApiRequestKey || {});

// src/services/events/index.ts
var getEventDetails = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-getEventDetailsAndRestrictions" /* GetEventDetails */,
    data: payload
  });
  return data;
};
var joinEvent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-joinEvent" /* JoinEvent */,
    data: payload
  });
  return data;
};
var createEvent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-createEvent" /* createEvent */,
    data: payload
  });
  return data;
};
var createEventWeb = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-createEventV2" /* createEventWeb */,
    data: payload
  });
  return data;
};
var eventGoLive = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-eventGoLive" /* eventGoLive */,
    data: payload
  });
  return data;
};
var getAllTicketsApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-getAllTickets" /* getAllTickets */,
    data: payload
  });
  return data;
};
var createPaymentSheetApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-createPaymentSheet" /* createPaymentSheet */,
    data: payload
  });
  return data;
};
var leaveEventApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-leaveEvent" /* leaveEvent */,
    data: payload
  });
  return data;
};
var leaveNonTicketedEventApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-leaveEvent" /* leaveEvent */,
    data: payload
  });
  return data;
};
var closeDownEvent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-closeDownEvent" /* closeDownEvent */,
    data: payload
  });
  return data;
};
var increaseInterestedCountApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-increaseInterestedCount" /* IncreaseInterestedCount */,
    data: payload
  });
  return data;
};
var validateToken = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-validateToken" /* validateToken */,
    data: payload
  });
  return data;
};
var markUserAsPermanent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-markUserAsPermanent" /* markUserAsPermanent */,
    data: payload
  });
  return data;
};
var getAllEvents = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-getAllEvents" /* getAllEvents */,
    data: payload
  });
  return data;
};
var onboardUserToStripe = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-onboardUser" /* onboardUserToStripe */,
    data: payload
  });
  return data;
};
var searchEvents = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-genericQueryForEventFn" /* searchEvent */,
    data: payload
  });
  return data;
};
var setPlusOnes = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-addPlusOnes" /* plusOnes */,
    data: payload
  });
  return data;
};
var getAcceptedGuestAvatarsApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-getAcceptedGuestAvatars" /* getAcceptedGuestAvatarsApi */,
    data: payload
  });
  return data;
};
var fetchGuestListForEvent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-fetchGuestListForEvent" /* fetchGuestListForEvent */,
    data: payload
  });
  return data;
};
var claimTicketForEvent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-claimTicket" /* claimTicketForEvent */,
    data: payload
  });
  return data;
};
var processGroupTicketsAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-processGroupTickets" /* processGroupTickets */,
    data: payload
  });
  return data;
};
var applyOrRemoveCoupon = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-applyOrRemoveCoupon" /* applyOrRemoveCoupon */,
    data: payload
  });
  return data;
};
var getEventTemplatesAPI = async (functions) => {
  const data = await callApi(functions, {
    path: "eventManagement-getEventTemplates" /* getEventTemplates */,
    data: {}
  });
  return data;
};
var joinWaitlistForEvent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-joinWaitlistForEvent" /* joinWaitlistForEvent */,
    data: payload
  });
  return data;
};
var addTicketsApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-addTickets" /* addTicket */,
    data: payload
  });
  return data;
};
var deleteTicketApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-deleteTicket" /* deleteTicket */,
    data: payload
  });
  return data;
};
var queryOpenAPIForDescription = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-queryOpenAPIForDescription" /* queryOpenAPIForDescription */,
    data: payload
  });
  return data;
};
var sendFeedbackForEvent = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-sendFeedbackForEvent" /* sendFeedbackForEvent */,
    data: payload
  });
  return data;
};
var updateTicketApi = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "eventManagement-updateTicket" /* updateTicket */,
    data: payload
  });
  return data;
};

// src/services/buddies/index.ts
var fetchSuggestedBuddies = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-getSuggestedPeople" /* getSuggestedPeople */,
    data: payload
  });
  return data;
};
var addBuddiesAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-addBuddy" /* addBuddy */,
    data: payload
  });
  return data;
};
var changePersonStatusAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-changePersonStatus" /* changePersonStatus */,
    data: payload
  });
  return data;
};

// src/services/groups/index.ts
var getGroupDetails = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "groupManagement-getGroupDetails" /* GetGroupDetails */,
    data: payload
  });
  return data;
};

// src/services/organization/index.ts
var createOrganizationAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "organizationManagement-createOrganization" /* createOrganization */,
    data: payload
  });
  return data;
};
var getOrganizationAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "organizationManagement-getOrganization" /* getOrganization */,
    data: payload
  });
  return data;
};
var followOrganizationAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "organizationManagement-followOrganization" /* followOrganization */,
    data: payload
  });
  return data;
};
var unfollowOrganizationAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "organizationManagement-unfollowOrganization" /* unfollowOrganization */,
    data: payload
  });
  return data;
};
var getOrganizationEventsAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "organizationManagement-getOrganizationEvents" /* getOrganizationEvents */,
    data: payload
  });
  return data;
};

// src/services/user/index.ts
var updateUserDetails = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-updateProfile" /* updateUserDetails */,
    data: payload
  });
  return data;
};
var getUserInfo = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-getBudddyInfo" /* getUserInfo */,
    data: payload
  });
  return data;
};
var updateEmailAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-updateEmail" /* updateEmail */,
    data: payload
  });
  return data;
};
var resendEmailVerificationAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-resendEmailVerification" /* resendEmailVerification */,
    data: payload
  });
  return data;
};
var deleteUserAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "authAndProfiles-deleteUser" /* deleteUser */,
    data: payload
  });
  return data;
};

// src/services/plugin/index.ts
var requestPluginAPI = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "pluginManagement-requestPlugin" /* requestPlugin */,
    data: payload
  });
  return data;
};

// src/services/openDoorExperiments/index.ts
var sendExperimentEngagementToSlack = async (functions, payload) => {
  const data = await callApi(functions, {
    path: "services-sendExperimentEngagementToSlack" /* sendExperimentEngagementToSlack */,
    data: payload
  });
  return data;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  EApiRequestKey,
  addBuddiesAPI,
  addTicketsApi,
  applyOrRemoveCoupon,
  callApi,
  changePersonStatusAPI,
  claimTicketForEvent,
  closeDownEvent,
  createEvent,
  createEventWeb,
  createOrganizationAPI,
  createPaymentSheetApi,
  deleteTicketApi,
  deleteUserAPI,
  eventGoLive,
  fetchGuestListForEvent,
  fetchSuggestedBuddies,
  followOrganizationAPI,
  getAcceptedGuestAvatarsApi,
  getAllEvents,
  getAllTicketsApi,
  getEventDetails,
  getEventTemplatesAPI,
  getGroupDetails,
  getOrganizationAPI,
  getOrganizationEventsAPI,
  getUserInfo,
  increaseInterestedCountApi,
  joinEvent,
  joinWaitlistForEvent,
  leaveEventApi,
  leaveNonTicketedEventApi,
  markUserAsPermanent,
  onboardUserToStripe,
  processGroupTicketsAPI,
  queryOpenAPIForDescription,
  requestPluginAPI,
  resendEmailVerificationAPI,
  searchEvents,
  sendExperimentEngagementToSlack,
  sendFeedbackForEvent,
  setPlusOnes,
  unfollowOrganizationAPI,
  updateEmailAPI,
  updateTicketApi,
  updateUserDetails,
  validateToken
});
